import gql from 'graphql-tag'

export default gql`
mutation CreateConversation($input: ConversationCreateInput!) {
  createConversation(
    input: $input
  ) {
    updatedAt,
    userId,
    userType,
    user {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    id,
    title,
    opponentId,
    opponentType,
    opponent {
      id,
      name,
      avatarId,
      photoFlag,
      email
    },
    unreads,
    internId
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/chat/mutations/create-conversation.mutation.js